import React from "react";
import { StaticQuery, graphql } from "gatsby";

import Approach from "../molecules/approach";

import Button from "../atoms/button";

import "../../scss/organisms/_our-approach.scss";

class OurApproach extends React.Component {
  render() {
    return (
      <section className="section our-approach pt-6 pb-7 section-grey section-shifted-right-blue">
        <div className="container">
          <div className="row">
            <div className="col-md-8 ml-auto">
              <h2 className="h4 mb-5">{this.props.title}</h2>
              <div className="row pt-3">
                <StaticQuery
                  query={graphql`
                    query ourApproachQuery {
                      enDeliverables: allContentfulDeliverable(
                        filter: { node_locale: { eq: "en-EU" } }
                      ) {
                        edges {
                          node {
                            id
                            title
                            description {
                              description
                            }
                            icon {
                              title
                              file {
                                url
                              }
                            }
                          }
                        }
                      }
                      nlDeliverables: allContentfulDeliverable(
                        filter: { node_locale: { eq: "nl-BE" } }
                      ) {
                        edges {
                          node {
                            id
                            title
                            description {
                              description
                            }
                            icon {
                              title
                              file {
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                  `}
                  render={data => {
                    const deliverables =
                      this.props.language && this.props.language === "nl"
                        ? data.nlDeliverables.edges
                        : data.enDeliverables.edges;

                    return (
                      <>
                        {deliverables.map(deliverable => {
                          return (
                            <div className="col-sm-6" key={deliverable.node.id}>
                              <Approach
                                title={deliverable.node.title}
                                description={
                                  deliverable.node.description.description
                                }
                                icon={deliverable.node.icon.file.url}
                                iconAlt={deliverable.node.icon.title}
                              />
                            </div>
                          );
                        })}
                      </>
                    );
                  }}
                />
                {/*
                <div className="col-sm-6">
                  <Approach
                    icon="/design/img/icons/process.svg"
                    iconAlt="Icon displaying a process"
                    title="Web applications"
                    description="Your digital platform should support the management of modular content. We deliver CMS implementations to create, manage and personalize modular intelligent content."
                  />
                </div>
                <div className="col-sm-6">
                  <Approach
                    icon="/design/img/icons/cloud.svg"
                    iconAlt="Icon displaying a cloud"
                    title="Ecommerce"
                    description="We implement strategic (e)commerce systems to sell your products or services online whether it’s in B2B, B2C or B2B2C."
                  />
                </div>
                <div className="col-sm-6">
                  <Approach
                    icon="/design/img/icons/speaker.svg"
                    iconAlt="Icon displaying a speaker"
                    title="Portals"
                    description="Digital customer service is key in to deliver a good customer experience, enabling you as an organization to get insights from analyzing the interactions in order to optimize your customer’s experience."
                  />
                </div>
                <div className="col-sm-6">
                  <Approach
                    icon="/design/img/icons/cogs.svg"
                    iconAlt="Icon displaying multiple cogs"
                    title="Marketing solutions"
                    description="Link your web application, portal or web shop to the right tools to deliver your brand identity and draw attention to your products and services and boost conversion."
                  />
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <Button type="secondary" to="solutions">
          {this.props.ctaTitle}
        </Button>
      </section>
    );
  }
}

export default OurApproach;
